import { parseISO } from 'date-fns';

const isString = v => typeof v === 'string';

export const getScheduleDateISO = state => state.schedule?.date;

export const getScheduleDate = (() => {
  let lastDateVal;
  let lastResult;
  return state => {
    try {
      const dateVal = state.schedule?.date;
      if (dateVal === lastDateVal && lastResult !== undefined) return lastResult;
      if (!dateVal) {
        lastDateVal = dateVal;
        lastResult = new Date();
        return lastResult;
      }
      lastResult = isString(dateVal) ? parseISO(dateVal) : dateVal;
      lastDateVal = dateVal;
      return lastResult;
    } catch (e) {
      lastDateVal = null;
      lastResult = new Date();
      return lastResult;
    }
  };
})();

export const getTodayUnavailabilitiesGroupedByInspector = (() => {
  let lastGroupedRef = null;
  let lastResult = null;
  return state => {
    const grouped = state.schedule?.todayUnavailabilitiesGroupedByInspector || {};
    if (grouped === lastGroupedRef && lastResult !== null) return lastResult;
    const parsed = {};
    Object.keys(grouped).forEach(key => {
      parsed[key] = (grouped[key] || []).map(item => ({
        ...item,
        start: isString(item.start) ? parseISO(item.start) : item.start,
        end: isString(item.end) ? parseISO(item.end) : item.end,
      }));
    });
    lastGroupedRef = grouped;
    lastResult = parsed;
    return lastResult;
  };
})();

export const getInspectorTodayUnavailabilities = (() => {
  let lastInspectorId = null;
  let lastGroupedRef = null;
  let lastResult = null;
  return (state, inspectorId) => {
    if (!inspectorId) return [];
    const grouped = getTodayUnavailabilitiesGroupedByInspector(state);
    if (inspectorId === lastInspectorId && grouped === lastGroupedRef) return lastResult || [];
    const result = grouped[inspectorId] || [];
    lastInspectorId = inspectorId;
    lastGroupedRef = grouped;
    lastResult = result;
    return result;
  };
})();

export const getFilteredInspectors = (() => {
  let lastInspectorsRef = null;
  let lastResult = null;
  return state => {
    const inspectors = state.schedule?.filteredInspectors || [];
    if (inspectors === lastInspectorsRef && lastResult !== null) return lastResult;
    const mapped = inspectors.map(inspector => ({
      ...inspector,
      todayUnavailabilities: (inspector.todayUnavailabilities || []).map(item => ({
        ...item,
        start: isString(item.start) ? parseISO(item.start) : item.start,
        end: isString(item.end) ? parseISO(item.end) : item.end,
      })),
      todayAvailabilities: (inspector.todayAvailabilities || []).map(item => ({
        ...item,
        start_time: isString(item.start_time) ? parseISO(item.start_time) : item.start_time,
        end_time: isString(item.end_time) ? parseISO(item.end_time) : item.end_time,
      })),
    }));
    lastInspectorsRef = inspectors;
    lastResult = mapped;
    return lastResult;
  };
})();

export const getInspectorOptions = (() => {
  let lastFilteredRef = null;
  let lastResult = null;
  return state => {
    const filtered = getFilteredInspectors(state);
    if (filtered === lastFilteredRef && lastResult !== null) return lastResult;
    const options = filtered.map(inspector => ({
      value: inspector.public_id,
      label: inspector.name,
      disabled: inspector?.status && inspector.status !== 'OK',
      status: inspector?.status,
      pendingOrderBasedMessage: inspector?.pendingOrderBasedMessage,
      todayAvailabilities: inspector?.todayAvailabilities || [],
      todayUnavailabilities: inspector?.todayUnavailabilities || [],
    }));
    lastFilteredRef = filtered;
    lastResult = options;
    return options;
  };
})();

export default {
  getScheduleDateISO,
  getScheduleDate,
  getTodayUnavailabilitiesGroupedByInspector,
  getInspectorTodayUnavailabilities,
  getFilteredInspectors,
  getInspectorOptions,
};
